import { render, staticRenderFns } from "./DomainsFilters.vue?vue&type=template&id=0b6a2278&scoped=true"
import script from "./DomainsFilters.vue?vue&type=script&lang=js"
export * from "./DomainsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a2278",
  null
  
)

export default component.exports